<script setup lang="ts">
import { useRouter } from 'vue-router';
import GaiaButton from '../base/GaiaButton.vue';
import GaiaEmptyState from './GaiaEmptyState.vue';

/**
 * The page-level "there is nothing here for you" state: an unknown URL, or a
 * record the backend refuses. The backend answers the same for "deleted",
 * "no access" and "belongs to another organisation" so it never confirms that
 * an object exists, and the default copy is just as non-committal.
 */
const props = withDefaults(
  defineProps<{
    title?: string;
    description?: string;
    /** Mono line under the copy, e.g. "404". */
    code?: string;
  }>(),
  {
    title: 'This page isn’t available',
    description: 'It may have been deleted, or you don’t have access to it in this organisation.',
    code: undefined,
  }
);

const router = useRouter();

function goHome(): void {
  void router.push({ name: 'home' });
}
</script>

<template>
  <gaia-empty-state :title="props.title">
    {{ props.description }}
    <template v-if="props.code" #meta>{{ props.code }}</template>
    <template #actions>
      <slot name="actions">
        <gaia-button type="primary" size="small" @click="goHome">Go back home</gaia-button>
      </slot>
    </template>
  </gaia-empty-state>
</template>
